import styled from "styled-components/macro";
import { Button as MuiButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ColorPalette, themePalette } from "../../../theme";

export type ButtonSize = "small" | "medium" | "large";

export const getButtonPadding = (size: ButtonSize): string => {
  if (size === "small") return "4px 16px";
  if (size === "medium") return "5px 20px";
  return "11px 24px";
};

export const getButtonFontSize = (size: ButtonSize): string => {
  if (size === "small") return "14px";
  if (size === "medium") return "18px";
  return "20px";
};

export const getBorder = (
  reverse: boolean | undefined,
  borderColor: string | undefined,
  backgroundColor: string | undefined,
  disabled: boolean | undefined,
): string => {
  if (reverse && disabled) {
    return `2px solid rgba(0, 0, 0, 0.26)`;
  }
  if (reverse) {
    return `2px solid ${backgroundColor || themePalette.redMedium}`;
  }
  if (borderColor) {
    return `1px solid ${borderColor || themePalette.redMedium}`;
  }
  return "0";
};

export const getBackground = (
  reverse: boolean | undefined,
  backgroundColor: string | undefined,
): string =>
  reverse ? themePalette.white : backgroundColor || themePalette.redMedium;

export const StyledButton = styled(MuiButton)<{
  size: ButtonSize;
  $backgroundColor?: keyof ColorPalette;
  $textColor?: keyof ColorPalette;
  $reverse?: boolean;
  $borderColor?: keyof ColorPalette;
}>`
  && {
    background: ${({ $reverse, $backgroundColor, theme }) =>
      getBackground($reverse, $backgroundColor && theme[$backgroundColor])};
    border-radius: 30px;
    border: ${({ $reverse, $borderColor, theme, $backgroundColor, disabled }) =>
      getBorder(
        $reverse,
        $borderColor && theme[$borderColor],
        $backgroundColor && theme[$backgroundColor],
        disabled,
      )};
    color: ${({ theme, $textColor, $reverse, $backgroundColor }) =>
      $reverse
        ? ($backgroundColor && theme[$backgroundColor]) || theme.redMedium
        : ($textColor && theme[$textColor]) || theme.white};
    padding: ${({ size }) => getButtonPadding(size)};
    font-size: ${({ size }) => getButtonFontSize(size)};
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    position: relative;
    opacity: ${({ disabled }) => (disabled ? 0.7 : "")};

    :hover {
      background: ${({ $reverse, $backgroundColor, theme }) =>
        getBackground($reverse, $backgroundColor && theme[$backgroundColor])};
      opacity: 0.8;
    }
  }
`;

export const ButtonSpinnerIcon = styled(FontAwesomeIcon)`
  font-size: inherit;
`;

export const ButtonHiddenLabel = styled.span`
  visibility: hidden;
`;

export const ButtonSpinnerWrapper = styled.span`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  padding-top: 2px;
`;
